//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchPagination from "./SearchPagination";
export default {
  components: {
    SearchPagination,
  },
  props: {
    searchPlaceholder: {
      type: String,
    },
    searchButtonText: {
      type: String,
    },
  },
  methods: {
    // checkForEnterKey: function (e) {
    //   if (e.keyCode === 13) {
    //     this.submitSearch();
    //   }
    // },
    setPage: function (index) {
      this.$emit("setPage", index);
    },
    submitSearch: function (e) {
			const input = this.$el.querySelector("input#search");
			if (input.value.length >= 3) {
	      this.$emit("submitSearch", this.query);
			}
    },
  },
  watch: {
    currentQuery() {
      this.query = this.$store.state.searchQuery.searchTerm;
    },
  },
  mounted: function () {
    this.query = this.currentQuery.searchTerm;
  },
  data: function () {
    return {
      query: "",
    };
  },
  computed: {
    settings: function () {
      return this.$store.state.settings;
    },

    currentResultStart: function () {
      if (this.results.currentPage == 0) {
        return 1;
      } else {
        return this.results.currentPage * this.results.pageSize + 1;
      }
    },
    currentResultsEnd: function () {
      if (this.results.currentPage == 0) {
        if (this.results.totalResultCount <= this.results.pageSize) {
          return this.results.totalResultCount;
        } else {
          return this.results.pageSize;
        }
      } else {
        var max = (this.results.currentPage + 1) * this.results.pageSize + 1;
        if (max > this.results.totalResultCount) {
          return this.results.totalResultCount;
        } else {
          return max;
        }
      }
    },
    results: function () {
      return this.$store.state.results;
    },
    currentQuery: function () {
      return this.$store.state.searchQuery;
    },
  },
};
